import { NumberInput as MantineNumerInput } from "@mantine/core";
import type { InputProps } from "../../types";

export const NumberInput = ({ value, handleChange }: InputProps<number>) => {
  return <MantineNumerInput onChange={handleChange} value={value} />;
};
